export default __webpack_public_path__ + "static/docs1-60e7b9cfbb8a77c81e2087cbb338cd11.png";